import { render, staticRenderFns } from "./choose-list.vue?vue&type=template&id=4a6a151f"
import script from "./choose-list.vue?vue&type=script&lang=js"
export * from "./choose-list.vue?vue&type=script&lang=js"
import style0 from "./choose-list.vue?vue&type=style&index=0&id=4a6a151f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports